import {createContext} from 'react';
import {ISearchCondition} from './types/filters';
import {ISearchGeneral, SEARCH_INIT} from './types/search';
import {ISearchField} from '../../common/searchType';

export interface AppSearchesData {
    search: ISearchGeneral;
    filters: ISearchCondition[];
    fields: ISearchField[];
    isOpen: boolean;
    isLoading: boolean;
    formSession: string;
    isDirty: boolean;
    handleOpen: () => void;
    handleChangeName: (value: string) => void;
    handleChangeDefaultAbsolute: () => void;
    handleChangeDefault: () => void;
    handleUpdateIgnoreCase: () => void;
    handleAddFilter: (field: ISearchField) => void;
    handleRemoveFilter: (columnID: number | Long) => void;
    handleSave: (...args: any) => any;
    handleClose: () => void;
    handleClear: () => void;
    handleUpdateFilter: (colID: number | Long, filter: ISearchCondition) => void;
    handleCancelQueries: () => void;
    onUpdateFiltersOrder: (orderedFilters: ISearchCondition[]) => void;
    getColumnByID: (id: number | Long) => ISearchField;
}

const defaultValue: AppSearchesData = {
    search: SEARCH_INIT,
    filters: [],
    fields: [],
    isOpen: false,
    isLoading: false,
    formSession: '',
    isDirty: false,
    handleOpen: () => null,
    handleChangeName: () => null,
    handleChangeDefaultAbsolute: () => null,
    handleChangeDefault: () => null,
    handleUpdateIgnoreCase: () => null,
    handleAddFilter: () => null,
    handleRemoveFilter: () => null,
    handleSave: () => null,
    handleClose: () => null,
    handleClear: () => null,
    handleUpdateFilter: () => null,
    handleCancelQueries: () => null,
    onUpdateFiltersOrder: () => null,
    getColumnByID: () => null
};

export const AppSearchesContext = createContext<AppSearchesData>(defaultValue);
